// Initialize single datetime pickers rendered by shared/_datetime_picker

function initOne(wrapper) {
  if (wrapper.dataset.dtpInitialized) return;
  const input = wrapper.querySelector('input.form-control');
  const dateSel = wrapper.dataset.dateHidden;
  const timeSel = wrapper.dataset.timeHidden;
  const dateHidden = dateSel ? document.querySelector(dateSel) : null;
  const timeHidden = timeSel ? document.querySelector(timeSel) : null;
  if (!input || !dateHidden || !timeHidden) return;

  wrapper.dataset.dtpInitialized = '1';

  // Prefill visible input only if hidden values exist; otherwise keep placeholder
  let initialDate = null;
  if (dateHidden.value && timeHidden.value) {
    try {
      const d = new Date(dateHidden.value + 'T' + timeHidden.value);
      if (!isNaN(d)) {
        initialDate = d;
        input.value = flatpickr.formatDate(d, 'd/m/Y H:i');
      }
    } catch (_) { }
  }

  if (typeof flatpickr === 'undefined') return;

  // Clear button plugin configuration
  const clearButtonPlugin = function (config) {
    return function (fp) {
      return {
        onReady() {
          const clearBtn = document.createElement('button');
          clearBtn.type = 'button';
          clearBtn.className = 'btn btn-sm btn-outline-secondary flatpickr-clear-btn';
          clearBtn.innerHTML = config.html || 'Clear';
          clearBtn.style.cssText = 'margin-left: 8px;';

          // Add clear button next to calendar container
          clearBtn.addEventListener('click', function (e) {
            e.preventDefault();
            fp.clear();
            // Clear hidden fields
            dateHidden.value = '';
            timeHidden.value = '';
            // For publish_at, also clear combined hidden field
            if (input.id === 'publish_at_display') {
              const pub = document.getElementById('publish_at_hidden');
              if (pub) pub.value = '';
            }
            // Clear validation errors
            input.classList.remove('is-invalid');
            const group = input.closest('.seamless-group') || input.closest('.range-group');
            if (group) group.classList.remove('invalid', 'is-invalid');
            const id = input.id;
            if (id) {
              const fb = document.getElementById(id + '_feedback');
              if (fb) { fb.style.display = 'none'; fb.textContent = ''; }
            }
            // Trigger change event
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });

          // Append to calendar container
          if (fp.calendarContainer) {
            fp.calendarContainer.appendChild(clearBtn);
          }
        }
      };
    };
  };

  // Track manual input state to prevent overwriting user input
  let isManuallyEditing = false;
  let manualInputTimeout = null;

  // Function to parse and sync manual input to hidden fields
  const syncManualInput = function () {
    const val = input.value.trim();
    if (val) {
      try {
        // Try to parse the manually entered date/time
        // Expected format: d/m/Y H:i (e.g., 30/10/2025 14:30)
        const parsed = flatpickr.parseDate(val, 'd/m/Y H:i');
        if (parsed && !isNaN(parsed.getTime())) {
          // Valid date parsed - update hidden fields immediately
          dateHidden.value = flatpickr.formatDate(parsed, 'Y-m-d');
          timeHidden.value = flatpickr.formatDate(parsed, 'H:i');

          // For publish_at, also update combined hidden field
          if (input.id === 'publish_at_display') {
            const pub = document.getElementById('publish_at_hidden');
            if (pub) pub.value = flatpickr.formatDate(parsed, 'Y-m-d\TH:i');
          }

          // Trigger change event for validation
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      } catch (err) {
        // Invalid format - keep manual input but don't update hidden fields yet
        console.log('Manual input not yet valid:', val);
      }
    }
    return false;
  };

  // Handle manual input changes and sync to hidden fields immediately
  input.addEventListener('input', function (e) {
    isManuallyEditing = true;

    // Clear any existing timeout
    if (manualInputTimeout) clearTimeout(manualInputTimeout);

    // Debounce: after 500ms of no input, try to parse and sync the value
    manualInputTimeout = setTimeout(() => {
      syncManualInput();
      isManuallyEditing = false;
    }, 500);
  });

  // Handle blur event - immediately sync when user leaves the field
  input.addEventListener('blur', function (e) {
    // Clear any pending timeout
    if (manualInputTimeout) {
      clearTimeout(manualInputTimeout);
      manualInputTimeout = null;
    }

    // Immediately try to sync the value
    syncManualInput();
    isManuallyEditing = false;
  });

  // Reset manual editing flag when picker opens via button click
  const iconWrapper = wrapper.querySelector('.date-icon-wrapper');
  if (iconWrapper) {
    iconWrapper.addEventListener('click', function () {
      isManuallyEditing = false;
    });
  }

  flatpickr(input, {
    enableTime: true,
    dateFormat: 'd/m/Y H:i',
    time_24hr: true,
    allowInput: true, // Enable manual input
    defaultDate: initialDate,
    plugins: [
      clearButtonPlugin({
        html: '<i class="fas fa-times-circle"></i> Clear'
      })
    ],
    onOpen: function (selectedDates, dateStr, instance) {
      // Don't override if user is actively typing
      if (isManuallyEditing) {
        return;
      }

      const now = new Date();
      now.setSeconds(0, 0);

      // Determine field type and minDate FIRST before restoring dates
      const isRegStart = (input.id === 'registration_start_datetime');
      const isRegEnd = (input.id === 'registration_end_datetime');
      const isPublish = (input.id === 'publish_at_display');

      // Set minDate first for registration fields so we can validate restored dates
      let minDateValue = null;
      if (isRegStart) {
        try { window.lastEditedRegistrationField = 'start'; } catch (_) { }
        // Registration Start: do not auto-set to now; enforce minDate = today on every open
        const todayMidnight = new Date();
        todayMidnight.setHours(0, 0, 0, 0);
        minDateValue = todayMidnight;
        try { instance.set('minDate', todayMidnight); } catch (_) { }
      } else if (isRegEnd) {
        try { window.lastEditedRegistrationField = 'end'; } catch (_) { }
        // Registration End: minDate will be set based on registration start date below
        // For now, default to today
        const todayMidnight = new Date();
        todayMidnight.setHours(0, 0, 0, 0);
        minDateValue = todayMidnight;
      } else if (isPublish) {
        const todayMidnight = new Date();
        todayMidnight.setHours(0, 0, 0, 0);
        minDateValue = todayMidnight;
      }

      // Determine current value from selectedDates or hidden fields
      // Validate against minDate to avoid invalid past dates
      let current = null;

      // If visible input is empty, check if we should restore from hidden fields or clear everything
      if (!input.value || input.value.trim() === '') {
        if (dateHidden.value && timeHidden.value) {
          // Restore visible input from hidden fields, but validate first
          try {
            const d = new Date(dateHidden.value + 'T' + timeHidden.value);
            if (!isNaN(d)) {
              // Check if date is valid (not before minDate for registration/publish fields)
              if (minDateValue && d < minDateValue) {
                // Date is in the past and invalid - clear hidden fields so defaults can apply
                dateHidden.value = '';
                timeHidden.value = '';
              } else {
                // Date is valid, restore it
                input.value = flatpickr.formatDate(d, 'd/m/Y H:i');
                current = d;
                // Set the date in Flatpickr instance
                instance.setDate(d, false);
              }
            }
          } catch (_) { }
        } else {
          // Only clear if both visible input AND hidden fields are empty
          try { if (instance.selectedDates && instance.selectedDates.length) instance.clear(); } catch (_) { }
          selectedDates = [];
        }
      } else {
        // Visible input has value, use it but validate if it's before minDate
        if (selectedDates && selectedDates.length > 0) {
          current = new Date(selectedDates[0]);
          // Validate current date
          if (minDateValue && current < minDateValue) {
            // Invalid date - clear it
            try {
              instance.clear();
              dateHidden.value = '';
              timeHidden.value = '';
              input.value = '';
              current = null;
            } catch (_) { }
          }
        } else {
          // Try to parse the visible input value
          try {
            const parsed = flatpickr.parseDate(input.value, 'd/m/Y H:i');
            if (parsed && !isNaN(parsed.getTime())) {
              // Validate parsed date
              if (minDateValue && parsed < minDateValue) {
                // Invalid date - clear it
                dateHidden.value = '';
                timeHidden.value = '';
                input.value = '';
                try { instance.clear(); } catch (_) { }
              } else {
                current = parsed;
                instance.setDate(parsed, false);
              }
            }
          } catch (_) { }
        }
      }

      // Final fallback: if still no current value but hidden fields exist, validate them
      if (!current && dateHidden.value && timeHidden.value) {
        try {
          const d = new Date(dateHidden.value + 'T' + timeHidden.value);
          if (!isNaN(d)) {
            // Only use if valid (not before minDate)
            if (!minDateValue || d >= minDateValue) {
              current = d;
            } else {
              // Invalid - clear hidden fields
              dateHidden.value = '';
              timeHidden.value = '';
            }
          }
        } catch (_) { }
      }

      if (isRegStart) {

        // Set default time to 12:00 for registration start field if:
        // 1. Completely empty (both date and time are blank) - for new invitations
        // 2. Date exists but time is blank - for existing invitations with blank time
        if (!current && (!dateHidden.value && !timeHidden.value)) {
          // Case 1: Both date and time are empty (new invitation)
          const todayAtNoon = new Date();
          todayAtNoon.setHours(12, 0, 0, 0);
          instance.setDate(todayAtNoon, false);
        } else if (!current && dateHidden.value && (!timeHidden.value || timeHidden.value.trim() === '')) {
          // Case 2: Date exists but time is blank (existing invitation with blank time)
          try {
            const parts = dateHidden.value.split('-');
            if (parts.length === 3) {
              const y = parseInt(parts[0], 10);
              const m = parseInt(parts[1], 10) - 1;
              const d = parseInt(parts[2], 10);
              const dateAtNoon = new Date(y, m, d, 12, 0, 0, 0);
              if (!isNaN(dateAtNoon)) {
                // Validate that the date is not in the past (before minDate)
                if (minDateValue && dateAtNoon < minDateValue) {
                  // Date is in the past - clear it and treat as empty (will default to today 12:00)
                  dateHidden.value = '';
                  timeHidden.value = '';
                  // Case 1 will handle setting default to today 12:00
                  const todayAtNoon = new Date();
                  todayAtNoon.setHours(12, 0, 0, 0);
                  instance.setDate(todayAtNoon, false);
                } else {
                  // Date is valid, set it with 12:00 time
                  instance.setDate(dateAtNoon, false);
                  // Update the hidden time field to reflect 12:00
                  timeHidden.value = '12:00';
                  // Update the visible input
                  input.value = flatpickr.formatDate(dateAtNoon, 'd/m/Y H:i');
                }
              }
            }
          } catch (_) { }
        }

        // Also cap maxDate to the selected event_start_date (inclusive)
        try {
          const esdInput = document.getElementById('event_start_date');
          if (esdInput && esdInput.value) {
            // Safe local parse for YYYY-MM-DD to avoid TZ shifts
            const parts = esdInput.value.split('-');
            if (parts.length === 3) {
              const y = parseInt(parts[0], 10);
              const m = parseInt(parts[1], 10) - 1;
              const d = parseInt(parts[2], 10);
              const eventStart = new Date(y, m, d, 23, 59, 59, 999);
              if (!isNaN(eventStart)) {
                instance.set('maxDate', eventStart);
              }
            }
          } else {
            // If no event_start_date yet, clear any previous maxDate
            instance.set('maxDate', null);
          }
        } catch (_) { }
      } else if (isRegEnd) {
        try { window.lastEditedRegistrationField = 'end'; } catch (_) { }
        // Registration End: do not auto-set now; enforce min/max based on registration start and event start

        // Set default time to 12:00 for registration end field ONLY if completely empty
        if (!current && !dateHidden.value && !timeHidden.value) {
          const todayAtNoon = new Date();
          todayAtNoon.setHours(12, 0, 0, 0);
          instance.setDate(todayAtNoon, false);
        }

        try {
          // minDate = registration_start_date (start of day)
          const rsdInput = document.getElementById('registration_start_date');
          if (rsdInput && rsdInput.value) {
            const p = rsdInput.value.split('-');
            if (p.length === 3) {
              const y = parseInt(p[0], 10), m = parseInt(p[1], 10) - 1, d = parseInt(p[2], 10);
              const rsDate = new Date(y, m, d, 0, 0, 0, 0);
              if (!isNaN(rsDate)) instance.set('minDate', rsDate);
            }
          } else {
            instance.set('minDate', null);
          }

          // maxDate = event_start_date (end of day)
          const esdInput = document.getElementById('event_start_date');
          if (esdInput && esdInput.value) {
            const p2 = esdInput.value.split('-');
            if (p2.length === 3) {
              const y2 = parseInt(p2[0], 10), m2 = parseInt(p2[1], 10) - 1, d2 = parseInt(p2[2], 10);
              const esDate = new Date(y2, m2, d2, 23, 59, 59, 999);
              if (!isNaN(esDate)) instance.set('maxDate', esDate);
            }
          } else {
            instance.set('maxDate', null);
          }
        } catch (_) { }
      } else if (isPublish) {
        // Send Invitation At: relax time-of-day limits; date within [today .. Registration Start DATE]
        const todayMidnight = new Date(); todayMidnight.setHours(0, 0, 0, 0);
        try { instance.set('minDate', todayMidnight); } catch (_) { }
        try {
          const rsdEl = document.getElementById('registration_start_date');
          if (rsdEl && rsdEl.value) {
            const p = rsdEl.value.split('-');
            if (p.length === 3) {
              const y = parseInt(p[0], 10), m = parseInt(p[1], 10) - 1, d = parseInt(p[2], 10);
              const maxDate = new Date(y, m, d, 23, 59, 59, 999);
              if (!isNaN(maxDate)) instance.set('maxDate', maxDate);
            }
          } else {
            instance.set('maxDate', null);
          }
        } catch (_) { }
      } else {
        // Default behavior for other fields: only set now when entirely empty on first open
        if ((!dateHidden.value || !timeHidden.value) && (!selectedDates || selectedDates.length === 0)) {
          instance.setDate(now, true);
        }
      }
    },
    onChange: function (selectedDates) {
      if (selectedDates.length > 0) {
        const d = selectedDates[0];
        dateHidden.value = flatpickr.formatDate(d, 'Y-m-d');
        timeHidden.value = flatpickr.formatDate(d, 'H:i');
        // For publish_at, also update combined hidden field
        if (input.id === 'publish_at_display') {
          const pub = document.getElementById('publish_at_hidden');
          if (pub) pub.value = flatpickr.formatDate(d, 'Y-m-d\TH:i');
        }
        // Avoid auto-clearing validation for registration and publish fields; let page logic decide
        const isRegistration = (input.id === 'registration_start_datetime' || input.id === 'registration_end_datetime' || input.id === 'publish_at_display');
        if (!isRegistration) {
          input.classList.remove('is-invalid');
          const group = input.closest('.seamless-group');
          if (group) group.classList.remove('invalid');
          const feedback = document.getElementById(input.id + '_feedback');
          if (feedback) { feedback.style.display = 'none'; feedback.textContent = ''; }
        }
      }
      // Reset manual editing flag after change is applied
      isManuallyEditing = false;
    },
    onClose: function (selectedDates) {
      const id = input.id;

      // If no date was selected but hidden fields have values, restore the visible input
      if (selectedDates.length === 0) {
        if (dateHidden.value && timeHidden.value) {
          try {
            const d = new Date(dateHidden.value + 'T' + timeHidden.value);
            if (!isNaN(d)) {
              input.value = flatpickr.formatDate(d, 'd/m/Y H:i');
            }
          } catch (_) { }
        }
        return;
      }
      try {
        if (id === 'registration_start_datetime') {
          if (typeof window.validateRegistrationStartTime === 'function') window.validateRegistrationStartTime();
          if (typeof window.validateRegistrationEndTime === 'function') window.validateRegistrationEndTime();
          if (typeof window.validatePublishAtTime === 'function') {
            try { window.validatePublishAtTime(); } catch (_) { }
          }
        } else if (id === 'registration_end_datetime') {
          if (typeof window.validateRegistrationEndTime === 'function') window.validateRegistrationEndTime();
          if (typeof window.validateRegistrationStartTime === 'function') window.validateRegistrationStartTime();
        } else if (id === 'publish_at_display') {
          if (typeof window.validatePublishAtTime === 'function') {
            try { window.validatePublishAtTime(selectedDates[0]); } catch (_) { }
          }
        }
      } catch (_) { }
    }
  });

}

export function initAllDateTimePickers() {
  document.querySelectorAll('[data-datetime-picker]').forEach(initOne);
}

document.addEventListener('turbolinks:load', initAllDateTimePickers);
document.addEventListener('DOMContentLoaded', initAllDateTimePickers);
